// extracted by mini-css-extract-plugin
export default {"EditNamePage":"styles_EditNamePage__NkU8A","fullWidth":"styles_fullWidth__c704z"};